import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { FileQuestion, LogIn } from 'lucide-react';
import { ROUTES, PLANNING_TABS } from '@/lib/constants/routes';
import { useAuth } from '@/hooks/useAuth';

export const NotFound = () => {
  const navigate = useNavigate();
  const { signOut, isAuthenticated } = useAuth();

  const handleGoToLogin = async () => {
    await signOut();
    navigate(ROUTES.LOGIN, { replace: true });
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted/50 p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-muted">
            <FileQuestion className="h-6 w-6 text-muted-foreground" />
          </div>
          <CardTitle className="text-2xl">Page not found</CardTitle>
          <CardDescription>
            The page you're looking for doesn't exist or has been moved.
          </CardDescription>
        </CardHeader>
        <CardContent className="flex flex-col gap-2">
          {isAuthenticated && (
            <Button onClick={() => navigate(`${ROUTES.PLANNING}?tab=${PLANNING_TABS.LIST}`)}>Go to Planning</Button>
          )}
          <Button variant="outline" onClick={handleGoToLogin}>
            <LogIn className="mr-2 h-4 w-4" />
            Go to Login
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

